import axios from 'app/api/base';
import IndexedDbService from 'app/services/IndexedDbService';
import { logout } from 'app/utils/helpers';
import store from 'store/index';

import { isWindow } from '.';

export const refreshToken = async () => {
  try {
    let res;

    const REQUEST_TIMEOUT = 10000;
    if (import.meta.env.VITE_APP_USE_AUTH_COOKIES === 'true') {
      const { refresh } = await IndexedDbService.getToken();
      res = await axios.post(
        '/api/v1/users/refresh_token/',
        { refresh },
        {
          timeout: REQUEST_TIMEOUT,
        }
      );
      await IndexedDbService.setToken(res.data.refresh);
    } else {
      res = await axios.post('/api/v1/users/refresh_token/', undefined, {
        timeout: REQUEST_TIMEOUT,
      });
    }

    const accessToken = res.data.access;
    store.dispatch({ type: 'SET_TOKEN', payload: accessToken });

    return Promise.resolve(accessToken);
  } catch (err) {
    logout();

    if (isWindow() && !window.location.pathname.includes('login')) {
      // Store the current URL to redirect back after login
      const currentPath = window.location.pathname + window.location.search;
      window.location.href = `/login?redirect_url=${encodeURIComponent(currentPath)}`;
    }

    return Promise.reject(err);
  }
};
